<template>
  <div class="container" id="live">
    <div class="live-container">
      <div class="live-video-box">
        <div class="video-top-box flex justify-between align-center">
          <div class="top-left ellipsis-1">
            <img
              class="play-symbol"
              src="../assets/images/live/play-symbol.png"
            />
            {{ currentVideo.name }}
          </div>
          <a class="top-right" target="_blank" :href="currentVideo.m_vhallUrl">
            <img class="tv" src="../assets/images/live/tv.png" />
            <a class="live-link" target="_blank" :href="currentVideo.m_vhallUrl"
              >进入直播间，登录观看参与抽奖</a
            >
          </a>
        </div>
        <div class="video-box">
          <iframe
            width="100%"
            height="100%"
            :src="currentVideo.m_liveUrl"
            frameborder="0"
            allowfullscreen="allowfullscreen"
            scrolling="no"
            allow="camera *;microphone *;"
            border="0"
            id="iframe"
          ></iframe>
        </div>
      </div>
      <div class="live-box">
        <div class="tabs flex">
          <div
            class="tab cs"
            @click="changeDate(date)"
            :class="{ active: currentDate === date.date }"
            v-for="(date, index) in liveDates"
            :key="index"
          >
            <span>{{ date.date }}</span>
            <div class="tab-active-bottom"></div>
          </div>
          <img
            class="tab-border-wap"
            src="../assets/images/live/tab-bg-mobile.png"
          />
        </div>
        <div class="live-classify-list">
          <div
            v-for="(videoType, index) in currentList"
            :key="index"
            v-show="videoType.list.length > 0"
            :class="{
              hide:
                openType !== videoType.title &&
                videoType.title !== '主题演讲' &&
                currentDate !== '06/16',
              main: videoType.title === '主题演讲',
            }"
            class="live-classify"
          >
            <div class="live-classify-top cs">
              <div class="dot"></div>
              <div
                class="title"
                :class="{
                  active:
                    videoType.title === currentVideo.liveType &&
                    currentDate === currentVideo.liveDate,
                }"
              >
                {{ videoType.title }}
              </div>
              <div
                v-show="currentDate !== '06/16' || $store.state.isMobile"
                class="fold-icon-box"
                :class="{
                  selected:
                    openType === videoType.title ||
                    videoType.title === '主题演讲',
                }"
              >
                <img
                  v-if="
                    videoType.title !== '主题演讲' && currentDate !== '06/16'
                  "
                  class="fold-icon"
                  src="../assets/images/live/arrow-down.png"
                  @click="openType = openType === '专场' ? '论坛' : '专场'"
                />
              </div>
            </div>
            <div
              class="live-list"
              v-if="
                videoType.title === openType ||
                !$store.state.isMobile ||
                videoType.title === '主题演讲' ||
                ($store.state.isMobile && currentDate === '06/16')
              "
            >
              <div
                class="live-item cs"
                @click="changeItem(video)"
                v-for="(video, videoIndex) in videoType.list"
                :key="videoIndex"
              >
                <div class="time">
                  {{ video.date }}
                  <span style="font-weight: 400">{{
                    video.m_liveAuth[0] === "闭门" ? "仅面向定邀受众" : ""
                  }}</span>
                </div>
                <div
                  :title="video.name"
                  class="title ellipsis-1"
                  :class="{
                    active: video.subSeminarId == currentVideo.subSeminarId,
                  }"
                >
                  {{ video.name }}
                </div>
                <div
                  class="status flex justify-start align-center"
                  :class="statusList[video.status]"
                >
                  <div class="status-dot"></div>
                  <div class="status-title">
                    {{ statusTitleList[video.status] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hot-broadcast
      :liveList="hotBroadcastList"
      v-if="timeStatus !== 'after' && hotBroadcastList.length > 0"
    ></hot-broadcast>
    <hot-recommend
      :liveList="hotRecommendList"
      v-if="timeStatus === 'after' && hotRecommendList.length > 0"
    ></hot-recommend>
    <!-- <unSignUp
      :tips="tips"
      :btn="btnText"
      ref="unSignUpDialog"
      @didClickunSignUp="didClickunSignUp"
    ></unSignUp> -->
    <noAccess ref="noAccessDialog"></noAccess>
  </div>
</template>
<script>
import { seminarAPI } from "@/services/modules/seminar";
import moment from "moment";
import { mapState } from "vuex";
import { $config } from "@/conf";
import Cookie from "js-cookie";
import _ from "lodash";

export default {
  name: "Live",
  data() {
    return {
      timeStatus: "before", //处理今日热播  和热门推荐
      liveDates: [
        {
          date: "06/15",
          child: [
            {
              title: "主题演讲",
              list: [],
            },
            {
              title: "论坛",
              list: [],
            },
            {
              title: "专场",
              list: [],
            },
          ],
        },
        {
          date: "06/16",
          child: [
            {
              title: "主题演讲",
              list: [],
            },
            {
              title: "论坛",
              list: [],
            },
            {
              title: "专场",
              list: [],
            },
          ],
        },
      ],
      statusList: ["not-started", "in-progress", "end", "playback"],
      statusTitleList: ["敬请期待", "直播中", "直播结束", "直播回顾"],
      videoList: [],
      currentVideo: {
        name: "",
        m_liveUrl: "",
        m_vhallLiveId: "",
        m_vhallUrl: "",
        liveType: "主题演讲",
        m_liveAuth: [""],
        m_closedUserIds: "",
      },
      currentType: "",
      currentDate: "",
      ids: [],
      tips: "您未报名，报名后有助于您使用更多功能",
      btnText: "去报名",
      hotBroadcastList: [],
      hotRecommendList: [],
      openType: "论坛",
      isNotData: true,
    };
  },
  computed: mapState({
    AttendanceStatus: (state) => state.userInfo.AttendanceStatus,
    userInfo: (state) => state.userInfo.info,
    isLogin: (state) => !!state.userInfo.token,
    tokenInfo: (state) => state.userInfo.token,
    nowTime: (state) => state.nowTime,
    currentList() {
      let list = [];
      this.liveDates.forEach((date) => {
        if (this.currentDate === date.date) {
          list = date.child;
        }
      });
      return list;
    },
  }),
  components: {
    // unSignUp: () => import("../components/dialog/type/UnSignUp.vue"),
    noAccess: () => import("../components/dialog/type/NoAccess.vue"),
    hotBroadcast: () => import("./live/HotBroadcast.vue"),
    hotRecommend: () => import("./live/HotRecommend.vue"),
  },

  mounted() {
    this.timeStatus = moment(this.nowTime).format("MM/DD");
    if (moment(this.nowTime).format("YYYYMMDD") > "20220616") {
      this.timeStatus = "after";
    }
    if (moment(this.nowTime).format("YYYYMMDD") < "20220615") {
      this.timeStatus = "before";
    }
    this.getList();
    const iframe = document.querySelector("#iframe");
    // 处理兼容行问题
    if (iframe && iframe.attachEvent) {
      iframe.attachEvent("onload", () => {
        //加载关闭提示框
        this.isNotData = false;
      });
    } else {
      iframe.onload = () => {
        //加载关闭提示框
        this.isNotData = false;
      };
    }
  },
  methods: {
    getLiveStatus(video, vhallStatus) {
      const startTime = moment(new Date(video.startTime * 1000));
      const endTime = moment(new Date(video.endTime * 1000));
      const nowTime = moment(this.nowTime);
      let status = 0;
      if (startTime > nowTime) {
        status = 0;
      }
      if (startTime <= nowTime && endTime > nowTime) {
        status = 1;
      }
      if (endTime < nowTime) {
        status = 1;
      }
      if (vhallStatus) {
        const statusItem = vhallStatus.find((item) => {
          return item.liveId == video.m_vhallLiveId;
        });
        if (statusItem && statusItem.status > 1) {
          status = statusItem.status;
        }
      }
      if (
        moment(nowTime).diff(moment(endTime), "minutes") > 60 &&
        status !== 3
      ) {
        status = 2;
      }
      return status;
    },
    //去登陆或报名
    didClickunSignUp() {
      this.$refs.unSignUpDialog.hideDialog();
      let channel = Cookie.get("channel");
      let nowUrl =
        `${window.location.origin + window.location.pathname}` +
        `?channel=${channel || ""}`;
      if (this.isLogin) {
        const { signOnlineUrl } = $config;
        window.location.href = `${signOnlineUrl}?channel=${
          channel || ""
        }&returnUrl=${encodeURIComponent(nowUrl)}`;
      } else {
        const smarketToken = this.tokenInfo.smarketToken || "";
        if (smarketToken) {
          const { signUpOfflineUrl } = $config;
          const { signUpOnlineUrl } = $config;
          if (this.$store.state.userInfo.AttendanceStatus != 1) {
            window.location.href = `${signUpOnlineUrl}?channel=${
              channel || ""
            }&returnUrl=${encodeURIComponent(nowUrl)}`;
          } else {
            window.location.href = `${signUpOfflineUrl}?channel=${
              channel || ""
            }&returnUrl=${encodeURIComponent(nowUrl)}`;
          }
        } else {
          const { signOnlineUrl } = $config;
          window.location.href = `${signOnlineUrl}?channel=${
            channel || ""
          }&returnUrl=${encodeURIComponent(nowUrl)}`;
        }
      }
    },
    changeItem(video) {
      this.isNotData = true;
      //埋码
      window._hw("send", "action", "index_meeting_living_click", {
        agenda_name: video.file_name,
        hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系
        product_tag: video.m_productTag
          ? video.m_productTag.substring(0, video.m_productTag.indexOf("$"))
          : "",
        industry_tag: video.m_industryTag
          ? video.m_industryTag.substring(0, video.m_industryTag.indexOf("$"))
          : "",
        sub_product_tag: video.m_productTag
          ? video.m_productTag.substring(
              video.m_productTag.indexOf("$") + 1,
              video.m_productTag.length
            )
          : "",
        sub_industry_tag: video.m_industryTag
          ? video.m_industryTag.substring(
              video.m_industryTag.indexOf("$") + 1,
              video.m_industryTag.length
            )
          : "",
        solution_tag: "",
      });
      if (video.m_liveAuth[0] === "闭门") {
        if (!this.isLogin) {
          this.$refs.unSignUpDialog.showDialog();
          return;
        }
        if (this.AttendanceStatus === 3) {
          this.$refs.unSignUpDialog.showDialog();
          return;
        } else {
          if (
            this.tokenInfo.cpAuth &&
            this.tokenInfo.cpAuth.split(",").indexOf(video.m_vhallLiveId) < 0
          ) {
            this.$refs.noAccessDialog.showDialog();
            return;
          } else {
            if (!this.tokenInfo.cpAuth) {
              this.$refs.noAccessDialog.showDialog();
              return;
            }
          }
        }
      }
      if (
        video.m_liveAuth[0] === "弱权限" &&
        (!this.isLogin || this.AttendanceStatus === 3)
      ) {
        this.$refs.unSignUpDialog.showDialog();
        return;
      }
      this.currentVideo = video;
      if (this.$store.state.isMobile) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
      //完成任务 区分下直播还是回看
      let desc = "";
      if (video.status == 1) {
        desc = "直播传送门";
      }
      if (video.status == 3) {
        desc = "追寻回声";
      }
      if (desc) {
        this.$store.dispatch("interaction/onCompleteTask", {
          desc: desc,
          objectId: video.subSeminarId,
          allLog: true, //总是记录日志 旅程报告要统计
        });
      }
    },

    changeDate(date) {
      this.currentDate = date.date;
      this.openType = "论坛";
    },
    getList() {
      this.currentDate =
        moment(this.nowTime).format("MMDD") !== "0616" ? "06/15" : "06/16";
      seminarAPI.getSubSeminarList().then((res) => {
        const ids = [];
        const items = res.content.items.filter((video) => {
          video.liveDate = moment(parseInt(video.startTime * 1000)).format(
            "MM/DD"
          );
          video.liveType = video.m_liveType[0];
          video.date =
            moment(parseInt(video.startTime * 1000)).format("HH:mm-") +
            moment(parseInt(video.endTime * 1000)).format("HH:mm");

          video.m_vhallUrl = this.$store.state.isMobile
            ? `${$config.vhallUrl}${video.m_vhallLiveId}.html`
            : `${$config.vhallUrl}${video.m_vhallLiveId}.html`;
          video.m_liveUrl =
            `https://vhall.huawei.com/v2/embed/${video.m_vhallLiveId}` +
            "?embed=video&lang=zh&thirdId=";
          if (video.m_liveType[0] && video.m_vhallLiveId) {
            ids.push(video.m_vhallLiveId);
          }
          return video.m_liveType[0] && video.m_vhallLiveId;
        });
        this.$api
          .getLiveStatusByIds({
            ids: ids.join(","),
          })
          .then((res) => {
            if (res.result === 0) {
              this.handleLiveList(items, res.content);
            } else {
              this.handleLiveList(items);
            }
          })
          .catch((e) => {
            this.handleLiveList(items);
          });
      });
    },
    handleLiveList(items, statusList) {
      const hotBroadcastList = [];
      const hotRecommendList = [];
      this.liveDates.forEach((liveDate) => {
        liveDate.child.forEach((video) => {
          video.list = items
            .filter((item) => {
              item.status = this.getLiveStatus(item, statusList);
              if (item.liveDate === this.timeStatus) {
                hotBroadcastList.push(item);
              }
              hotRecommendList.push(item);
              // 如果是2022/06/15 12:00:00  - 2022/06/16 00:00:00  播放下午场  其他时间 默认播放上午场
              if (
                moment(this.nowTime).diff(
                  moment("2022/06/15 12:00:00"),
                  "seconds"
                ) > 0 &&
                moment(this.nowTime).diff(
                  moment("2022/06/16 00:00:00"),
                  "seconds"
                ) < 0
              ) {
                if (item.subSeminarId == this.$config.afternoonMainSeminarId) {
                  this.currentVideo = item;
                }
              } else {
                if (item.subSeminarId == this.$config.morningMainSeminarId) {
                  this.currentVideo = item;
                }
              }
              return (
                item.liveDate === liveDate.date && item.liveType === video.title
              );
            })
            .sort((a, b) => {
              if (a.startTime - b.startTime !== 0) {
                return a.startTime - b.startTime;
              }
              if (a.endTime - b.endTime !== 0) {
                return a.endTime - b.endTime;
              }
              return a.createTime - b.createTime;
            });
        });
      });
      this.hotBroadcastList = _.uniqWith(hotBroadcastList);
      this.hotRecommendList = _.uniqWith(hotRecommendList);
      // this.hotBroadcastList =hotBroadcastList;
      // this.hotRecommendList = hotRecommendList;
      this.changeDate({
        date: this.currentDate,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
//mobile begin
@media screen and (max-width: 992px) {
  @import "./live/css/wap.scss";
}
//mobile end

//pc begin
@media screen and (min-width: 992px) {
  @import "./live/css/pc.scss";
}
//pc end

//折叠屏 begin
@media (aspect-ratio: 700/701) {
}

//折叠屏 end
</style>
